import { usePermissions } from './index';

/**
 * Whether the current user may manage this team's templates (team admin or
 * manage_templates) — the rule the API applies to publishing, folders,
 * sharing and checklist templates. `null` while permissions are loading, so
 * callers can wait instead of flashing a no-access state.
 */
export function useCanManageTemplates(): boolean | null {
  const { isAdmin, hasPermission } = usePermissions({ ignoreDeal: true });
  if (isAdmin) return true;
  const allowed = hasPermission('manage_templates');
  return allowed === null ? null : allowed === true;
}
